import script from "./ConsumerCheckoutView.vue?vue&type=script&setup=true&lang=js"
export * from "./ConsumerCheckoutView.vue?vue&type=script&setup=true&lang=js"

import "./ConsumerCheckoutView.vue?vue&type=style&index=0&id=25562024&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25562024"]])

export default __exports__